module.exports = __webpack_public_path__ + "static/media/player-blank.e997ff59.svg";